import React from 'react';
import AnimeCard from './AnimeCard';
import MangaCard from './MangaCard';
import './FixedGenreGrid.css';

const FixedGenreGrid = ({ items, layout = "horizontal", type = "anime" }) => {
  // Validation check
  if (!items || !Array.isArray(items) || items.length === 0) {
    return (
      <div className="fixed-genre-empty">
        <p>No {type} available in this category.</p>
      </div>
    );
  }

  return (
    <div className={`fixed-genre-grid ${layout}-layout`}>
      {items.map((item) => (
        <div key={item._id || item.id || item.mal_id || 'unknown'} className="fixed-card-wrapper">
          {type === "anime" ? (
            <AnimeCard anime={item} layout={layout} />
          ) : (
            <MangaCard manga={item} layout={layout} />
          )}
        </div>
      ))}
    </div>
  );
};

export default FixedGenreGrid;